import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';

class StaffPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
		}
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-users"></i>&nbsp; Staff</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item active">
				<Link to="/employee/usertype" className="nav-link" >UserType</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/employee/department" className="nav-link" >Department</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/employee/designation" className="nav-link" >Designation</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/employee/employee" className="nav-link" >Employee Registration</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/employee/list" className="nav-link" >Employee List</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/employee/attendance" className="nav-link" >Attendance</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default StaffPage;


// WEBPACK FOOTER //
// ./src/views/StaffPage/StaffPage.js